// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-dices {
  display: flex;
  flex-direction: column;
  min-width: 54px;
  padding-left: 11px;
  margin-bottom: 10px;
  margin-top: auto;
}
.chat-dices > span {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 0.9em;
  margin: 7px 11px 0;
  opacity: 0.8;
  font-weight: 600;
  text-shadow: 0 -2px 0 rgba(0, 0, 0, 0.63), 0 -2px 0 rgba(0, 0, 0, 0.63), 0 2px 0 rgba(0, 0, 0, 0.63), 0 2px 0 rgba(0, 0, 0, 0.63), -2px 0 0 rgba(0, 0, 0, 0.63), 2px 0 0 rgba(0, 0, 0, 0.63), -2px 0 0 rgba(0, 0, 0, 0.63), 2px 0 0 rgba(0, 0, 0, 0.63), -1px -2px 0 rgba(0, 0, 0, 0.63), 1px -2px 0 rgba(0, 0, 0, 0.63), -1px 2px 0 rgba(0, 0, 0, 0.63), 1px 2px 0 rgba(0, 0, 0, 0.63), -2px -1px 0 rgba(0, 0, 0, 0.63), 2px -1px 0 rgba(0, 0, 0, 0.63), -2px 1px 0 rgba(0, 0, 0, 0.63), 2px 1px 0 rgba(0, 0, 0, 0.63), -2px -2px 0 rgba(0, 0, 0, 0.63), 2px -2px 0 rgba(0, 0, 0, 0.63), -2px 2px 0 rgba(0, 0, 0, 0.63), 2px 2px 0 rgba(0, 0, 0, 0.63), -2px -2px 0 rgba(0, 0, 0, 0.63), 2px -2px 0 rgba(0, 0, 0, 0.63), -2px 2px 0 rgba(0, 0, 0, 0.63), 2px 2px 0 rgba(0, 0, 0, 0.63);
  color: #FAFAFA;
}
.chat-dices__container {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.chat-dices__number-container {
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.chat-dices__number-frame {
  width: 28px;
  height: 28px;
}
.chat-dices__number-frame--yellow [fill="#BDBD7D"] {
  fill: #C5D321;
}
.chat-dices__number-frame--blue [fill="#BDBD7D"] {
  fill: #7175D6;
}
.chat-dices__number-frame--purple [fill="#BDBD7D"] {
  fill: #A062C9;
}
.chat-dices__number-frame--red [fill="#BDBD7D"] {
  fill: #F78C8C;
}
.chat-dices__number-frame--green [fill="#BDBD7D"] {
  fill: #5DAD60;
}
.chat-dices__number {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  position: absolute;
  color: #000000;
  font-weight: bold;
  font-size: 21px;
}
.chat-dices__row-container {
  display: flex;
  align-items: center;
  gap: 9px;
}
.chat-dices__row-container--yellow .chat-dices__card--selected [fill=white] {
  fill: #C5D321;
}
.chat-dices__row-container--red .chat-dices__card--selected [fill=white] {
  fill: #F78C8C;
}
.chat-dices__row-container--green .chat-dices__card--selected [fill=white] {
  fill: #5DAD60;
}
.chat-dices__row-container--blue .chat-dices__card--selected [fill=white] {
  fill: #7175D6;
}
.chat-dices__row-container--purple .chat-dices__card--selected [fill=white] {
  fill: #A062C9;
}
.chat-dices__button {
  display: flex;
  opacity: 0.5;
  transform: scale(1);
  transition: opacity 200ms, transform 200ms, fill 200ms;
}
.chat-dices__button--yellow:hover [fill=white] {
  fill: #C5D321;
}
.chat-dices__button--red:hover [fill=white] {
  fill: #F78C8C;
}
.chat-dices__button--green:hover [fill=white] {
  fill: #5DAD60;
}
.chat-dices__button--blue:hover [fill=white], .chat-dices__button--blue.chat-dices__card--selected [fill=white] {
  fill: #7175D6;
}
.chat-dices__button--purple:hover [fill=white], .chat-dices__button--purple.chat-dices__card--selected [fill=white] {
  fill: #A062C9;
}
.chat-dices__button--disabled {
  pointer-events: none;
}
.chat-dices__heart-button--hover {
  display: none;
}
.chat-dices__heart-button__container {
  display: flex;
  opacity: 0.8;
  transform: scale(1);
  transition: opacity 200ms, transform 200ms;
}
.chat-dices__heart-button__container:hover {
  opacity: 0.5;
}
.chat-dices__heart-button__container:hover .chat-dices__heart-button {
  display: none;
}
.chat-dices__heart-button__container:hover .chat-dices__heart-button--hover {
  display: flex;
}
.chat-dices__heart-button__container:active {
  transform: scale(0.88);
}
.chat-dices__card {
  opacity: 0.5;
  width: 26px;
  height: 41px;
}
.chat-dices__button:hover, .chat-dices__card--selected {
  opacity: 0.8;
  transform: scale(1.125);
}
.chat-dices__button:active {
  transform: scale(0.88);
}

.icon-d100:hover .to-color {
  fill: #A062C9;
}
.icon-d12:hover .to-color {
  fill: #5DAD60;
}
.icon-d6:hover .to-color {
  fill: #F78C8C;
}
.icon-d20:hover .to-color {
  fill: #7175D6;
}
.icon-coin:hover .to-color {
  fill: #BDBD7D;
}

.dice {
  opacity: 0.5;
  margin: auto;
}
.dice .to-color {
  fill: white;
}
.dice:hover {
  width: 54px;
  height: 54px;
  cursor: pointer;
  opacity: 0.8;
}

.dice-wrapper {
  display: flex;
  width: 54px;
  height: 54px;
  margin: auto auto 0 auto;
  transition: all 0.1s ease;
}
.dice-wrapper:active .dice {
  width: 38px;
}`, "",{"version":3,"sources":["webpack://./src/constructorComponents/chat/dices/styles.scss"],"names":[],"mappings":"AASA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AARJ;AASI;EAEI,yDAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACE,uvBACA;EAwBA,cAAA;AAhCV;AAoCI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAlCR;AAqCI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAnCR;AAsCI;EACI,WAAA;EACA,YAAA;AApCR;AAsCQ;EACI,aAvEC;AAmCb;AAuCQ;EACI,aAxEA;AAmCZ;AAwCQ;EACI,aA3ED;AAqCX;AAyCQ;EACI,aAlFA;AA2CZ;AA0CQ;EACI,aArFL;AA6CP;AA4CI;EACI,yDAAA;EACA,kBAAA;EACA,cAzFA;EA0FA,iBAAA;EACA,eAAA;AA1CR;AA6CI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AA3CR;AA6CQ;EACI,aAzGC;AA8Db;AA8CQ;EACI,aA5GA;AAgEZ;AA+CQ;EACI,aA/GL;AAkEP;AAgDQ;EACI,aAlHA;AAoEZ;AAiDQ;EACI,aArHD;AAsEX;AAmDI;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,sDAAA;AAjDR;AAmDQ;EACI,aApIC;AAmFb;AAmDQ;EACI,aAtIA;AAqFZ;AAmDQ;EACI,aAxIL;AAuFP;AAmDQ;EACI,aA1IA;AAyFZ;AAmDQ;EACI,aA5ID;AA2FX;AAoDQ;EACI,oBAAA;AAlDZ;AAsDI;EACI,aAAA;AApDR;AAuDI;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,0CAAA;AArDR;AAsDQ;EACI,YAAA;AApDZ;AAqDY;EACI,aAAA;AAnDhB;AAqDY;EACI,aAAA;AAnDhB;AAsDQ;EACI,sBAAA;AApDZ;AAwDI;EACI,YAAA;EACA,WAAA;EACA,YAAA;AAtDR;AAyDI;EACI,YAAA;EACA,uBAAA;AAvDR;AA0DI;EACI,sBAAA;AAxDR;;AAgEY;EACI,aAAA;AA7DhB;AAoEY;EACI,aAAA;AAlEhB;AAyEY;EACI,aAAA;AAvEhB;AA8EY;EACI,aAAA;AA5EhB;AAmFY;EACI,aAAA;AAjFhB;;AAuFA;EACI,YAAA;EACA,YAAA;AApFJ;AAqFI;EACI,WAAA;AAnFR;AAqFI;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AAnFR;;AAsFA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,yBAAA;AAnFJ;AAoFI;EACI,WAAA;AAlFR","sourcesContent":["$regular: 200ms;\r\n$keyLimePie: #C5D321;\r\n$geraldine: #F78C8C;\r\n$fern: #5DAD60;\r\n$moodyBlue: #7175D6;\r\n$amethyst: #A062C9;\r\n$black: #000000;\r\n\r\n\r\n.chat-dices {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-width: 54px;\r\n    padding-left: 11px;\r\n    margin-bottom: 10px;\r\n    margin-top: auto;\r\n    > span {\r\n        // Same label look as chat/styles.scss's .text (sentence case, outlined).\r\n        font-family: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\r\n        font-size: 0.9em;\r\n        margin: 7px 11px 0;\r\n        opacity: 0.8;\r\n        font-weight: 600;\r\n          text-shadow: \r\n          -0   -2px 0   rgba( 0, 0, 0, 0.63 ),\r\n           0   -2px 0   rgba( 0, 0, 0, 0.63 ),\r\n          -0    2px 0   rgba( 0, 0, 0, 0.63 ),\r\n           0    2px 0   rgba( 0, 0, 0, 0.63 ),\r\n          -2px -0   0   rgba( 0, 0, 0, 0.63 ),\r\n           2px -0   0   rgba( 0, 0, 0, 0.63 ),\r\n          -2px  0   0   rgba( 0, 0, 0, 0.63 ),\r\n           2px  0   0   rgba( 0, 0, 0, 0.63 ),\r\n          -1px -2px 0   rgba( 0, 0, 0, 0.63 ),\r\n           1px -2px 0   rgba( 0, 0, 0, 0.63 ),\r\n          -1px  2px 0   rgba( 0, 0, 0, 0.63 ),\r\n           1px  2px 0   rgba( 0, 0, 0, 0.63 ),\r\n          -2px -1px 0   rgba( 0, 0, 0, 0.63 ),\r\n           2px -1px 0   rgba( 0, 0, 0, 0.63 ),\r\n          -2px  1px 0   rgba( 0, 0, 0, 0.63 ),\r\n           2px  1px 0   rgba( 0, 0, 0, 0.63 ),\r\n          -2px -2px 0   rgba( 0, 0, 0, 0.63 ),\r\n           2px -2px 0   rgba( 0, 0, 0, 0.63 ),\r\n          -2px  2px 0   rgba( 0, 0, 0, 0.63 ),\r\n           2px  2px 0   rgba( 0, 0, 0, 0.63 ),\r\n          -2px -2px 0   rgba( 0, 0, 0, 0.63 ),\r\n           2px -2px 0   rgba( 0, 0, 0, 0.63 ),\r\n          -2px  2px 0   rgba( 0, 0, 0, 0.63 ),\r\n           2px  2px 0   rgba( 0, 0, 0, 0.63 );\r\n          color: #FAFAFA;\r\n\r\n    }\r\n\r\n    &__container {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 6px;\r\n    }\r\n\r\n    &__number-container {\r\n        width: 48px;\r\n        height: 48px;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        position: relative;\r\n    }\r\n\r\n    &__number-frame {\r\n        width: 28px;\r\n        height: 28px;\r\n\r\n        &--yellow [fill=\"#BDBD7D\"] {\r\n            fill: $keyLimePie;\r\n        }\r\n\r\n        &--blue [fill=\"#BDBD7D\"] {\r\n            fill: $moodyBlue;\r\n        }\r\n\r\n        &--purple [fill=\"#BDBD7D\"] {\r\n            fill: $amethyst;\r\n        }\r\n\r\n        &--red [fill=\"#BDBD7D\"] {\r\n            fill: $geraldine;\r\n        }\r\n\r\n        &--green [fill=\"#BDBD7D\"] {\r\n            fill: $fern;\r\n        }\r\n    }\r\n\r\n    &__number {\r\n        font-family: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\r\n        position: absolute;\r\n        color: $black;\r\n        font-weight: bold;\r\n        font-size: 21px;\r\n    } \r\n\r\n    &__row-container {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 9px;\r\n\r\n        &--yellow .chat-dices__card--selected [fill='white']{\r\n            fill: $keyLimePie;\r\n        }\r\n\r\n        &--red .chat-dices__card--selected [fill='white']{\r\n            fill: $geraldine;\r\n        }\r\n\r\n        &--green .chat-dices__card--selected [fill='white']{\r\n            fill: $fern;\r\n        }\r\n\r\n        &--blue .chat-dices__card--selected [fill='white']{\r\n            fill: $moodyBlue;\r\n        }\r\n\r\n        &--purple .chat-dices__card--selected [fill='white']{\r\n            fill: $amethyst;\r\n        }\r\n    }\r\n\r\n    &__button {\r\n        display: flex;\r\n        opacity: 0.5;\r\n        transform: scale(1);\r\n        transition: opacity $regular, transform $regular, fill $regular;\r\n\r\n        &--yellow:hover [fill='white']{\r\n            fill: $keyLimePie;\r\n        }\r\n        &--red:hover [fill='white']{\r\n            fill: $geraldine;\r\n        }\r\n        &--green:hover [fill='white']{\r\n            fill: $fern;\r\n        }\r\n        &--blue:hover [fill='white'], &--blue.chat-dices__card--selected [fill='white']{\r\n            fill: $moodyBlue;\r\n        }\r\n        &--purple:hover [fill='white'], &--purple.chat-dices__card--selected [fill='white']{\r\n            fill: $amethyst;\r\n        }\r\n\r\n        &--disabled {\r\n            pointer-events: none;\r\n        }\r\n    }\r\n\r\n    &__heart-button--hover {\r\n        display: none;\r\n    }\r\n\r\n    &__heart-button__container {\r\n        display: flex;\r\n        opacity: 0.8;\r\n        transform: scale(1);\r\n        transition: opacity $regular, transform $regular;\r\n        &:hover {\r\n            opacity: 0.5;\r\n            & .chat-dices__heart-button {\r\n                display: none;\r\n            }\r\n            & .chat-dices__heart-button--hover {\r\n                display: flex;\r\n            }\r\n        }\r\n        &:active {\r\n            transform: scale(0.88);\r\n        }\r\n    }\r\n\r\n    &__card {\r\n        opacity: 0.5;\r\n        width: 26px;\r\n        height: 41px;\r\n    }\r\n\r\n    &__button:hover, &__card--selected  {\r\n        opacity: 0.8;\r\n        transform: scale(1.125);\r\n    }\r\n\r\n    &__button:active {\r\n        transform: scale(0.88);\r\n    }\r\n\r\n}\r\n\r\n.icon {\r\n    &-d100 {\r\n        &:hover {\r\n            .to-color {\r\n                fill: #A062C9;\r\n                \r\n            }\r\n        }\r\n    }\r\n    &-d12 {\r\n        &:hover {\r\n            .to-color {\r\n                fill: #5DAD60;\r\n                \r\n            }\r\n        }\r\n    }\r\n    &-d6 {\r\n        &:hover {\r\n            .to-color {\r\n                fill: #F78C8C;\r\n                \r\n            }\r\n        }\r\n    }\r\n    &-d20 {\r\n        &:hover {\r\n            .to-color {\r\n                fill: #7175D6;\r\n                \r\n            }\r\n        }\r\n    }\r\n    &-coin {\r\n        &:hover {\r\n            .to-color {\r\n                fill: #BDBD7D; \r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.dice {\r\n    opacity: 0.5;\r\n    margin: auto;\r\n    .to-color {\r\n        fill: white;\r\n    }\r\n    &:hover {\r\n        width: 54px;\r\n        height: 54px;\r\n        cursor: pointer;\r\n        opacity: 0.80;\r\n    }\r\n}\r\n.dice-wrapper {\r\n    display: flex;\r\n    width: 54px;\r\n    height: 54px;\r\n    margin: auto auto 0 auto;\r\n    transition: all 0.1s ease;\r\n    &:active .dice {\r\n        width: 38px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
